module.exports = __webpack_public_path__ + "static/media/BUSDT.20acc220.svg";